import { render, staticRenderFns } from "./ModalFaceInference.vue?vue&type=template&id=17961a2c"
import script from "./ModalFaceInference.vue?vue&type=script&lang=js"
export * from "./ModalFaceInference.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports